<template>
  <div>
    <div class="bg-white rounded-[16px] p-[16px]">
      <div v-if="givingType === 'offering'" class="rounded-[16px] bg-[#F6F4F0] py-[16px] mb-4">
        <img
          src="https://assets-cdn.heartofgodchurch.org/give/main/qr-offering.png"
          class="h-[200px] w-[200px] md:h-[280px] md:w-[280px] lg:h-[320px] lg:w-[320px] mx-auto"
        />
        <p
          class="italic text-center text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] mt-[8px] md:hidden"
        >
          Tap and hold to save image
        </p>
      </div>
      <div class="flex flex-row items-center justify-between mb-2">
        <p>UEN: <b>S99SS0059K</b></p>
        <p
          class="block p-[4px] rounded-[8px] bg-[#E5F0FF] cursor-pointer"
          @click="copyClipboard('generic-qr-code-copy-1', 'S99SS0059K')"
        >
          <svg
            class="inline"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
              stroke="#0D5DF5"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
              stroke="#0D5DF5"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            id="generic-qr-code-copy-1"
            class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.375rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#0D5DF5] font-medium"
            >Copy</span
          >
        </p>
      </div>
      <div v-if="givingType !== 'offering'" class="">
        <p
          class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#0D5DF5] cursor-pointer"
          @click="showReferenceInfo = true"
        >
          <img
            src="/assets/images/my-giving/paynow/info-tooltip.svg"
            class="inline mr-[4px] md:mr-[8px] lg:mr-[10px] w-[20px] h-[20px] md:w-[24px] md:h-[24px] lg:w-[28px] lg:h-[28px]"
          />
          <span>What is my Reference No.?</span>
        </p>
        <div
          v-if="showReferenceInfo"
          class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#000]"
        >
          <ul class="list-disc pl-5 mt-[8px]" v-html="referenceNumberHelper"></ul>
          <p>
            <i>e.g. {{ referenceNumberExample }}</i>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    referenceText: {
      type: String,
      default: 'Offering',
    },
    givingType: {
      type: String,
      default: 'offering',
    },
  },
  data() {
    return {
      showReferenceInfo: false,
    };
  },
  computed: {
    referenceNumberHelper() {
      switch (this.givingType) {
        case 'Tithe':
          return `<li>Last 4 characters of your NRIC</li>
            <li>Birthdate in DDMM format</li>
            <li>Month of Giving (only for One-time giving)</li>
            <li>Nature of Giving (‘T’ - Tithe)</li>`;
        case 'Building Fund':
          return `<li>Last 4 characters of your NRIC</li>
            <li>Birthdate in DDMM format</li>
            <li>Month of Giving (only for One-time giving)</li>
            <li>Nature of Giving (‘B’ - Building Fund)</li>`;
        case 'Heart Community Services':
          return `<li>Last 4 characters of your NRIC</li>
            <li>Birthdate in DDMM format</li>
            <li>Month of Giving (only for One-time giving)</li>
            <li>Nature of Giving (‘H’ - Heart Community Services)</li>`;
        case 'Missions':
          return `<li>Last 4 characters of your NRIC</li>
            <li>Birthdate in DDMM format</li>
            <li>Month of Giving (only for One-time giving)</li>
            <li>Nature of Giving (‘M’ - Missions)</li>`;
        case 'GenerationS Fund':
          return `<li>Last 4 characters of your NRIC</li>
            <li>Birthdate in DDMM format</li>
            <li>Nature of Giving (GENS)</li>`;
        case 'Offering':
          return ``;
        default:
          return ``;
      }
    },
    referenceNumberExample() {
      switch (this.givingType) {
        case 'Tithe':
          return `123A3108JANT`;
        case 'Building Fund':
          return `123A3108JANB`;
        case 'Heart Community Services':
          return `123A3108JANH`;
        case 'Missions':
          return `123A3108JANM`;
        case 'GenerationS Fund':
          return `123A3108GENS`;
        case 'Offering':
          return ``;
        default:
          return ``;
      }
    },
  },
  methods: {
    copyClipboard(id, target) {
      const element = document.getElementById(id);
      element.innerText = 'Copied';
      navigator.clipboard.writeText(target);
      setTimeout(() => this.removeCopyText(id), 1500);
    },
    removeCopyText(id) {
      const element = document.getElementById(id);
      element.innerText = 'Copy';
    },
  },
};
</script>

<style scoped lang="scss"></style>
